<script lang="ts">
import { defineComponent, PropType } from "vue";
import KlereoBanner from "@/shared/components/KlereoBanner.vue";
import { PoolListItem } from "@/models/pool-list-item.model";
import { apiService } from "@/services/services";
import PromiseWrapper from "@/shared/components/PromiseWrapper.vue";
import { Note } from "@/features/notes/api/notes.models";
import { Nullable } from "@/models/nullable.type";
import { notesServices } from "@/features/notes/api/notes.service";
import LoadingOverlay from "@/shared/components/LoadingOverlay.vue";
import { injectToken } from "@/shared/utils/injection";

export default defineComponent({
  components: { LoadingOverlay, PromiseWrapper, KlereoBanner },
  emits: ["back"],
  ...injectToken,
  data() {
    return {
      saving: false,
      savingError: undefined as any,
      message: "" as string,
      // @ts-ignore
      poolID: this.lastPool?.idSystem ?? 0,
      notes: [] as Note[],
      pools: [] as PoolListItem[],
      promise: undefined as Nullable<Promise<void>>,
      refreshing: false,
    };
  },
  props: {
    note: {
      required: false,
      type: Object as PropType<Note>,
    },
  },
  created() {
    this.promise = apiService
      .listPools()
      .then((list) => (this.pools = list.response))
      .then(() => {
        if (this.note) {
          this.message = this.note.message;
        }
      });
  },
  watch: {
    note() {
      if (this.note) {
        this.message = this.note.message;
      }
    },
  },
  computed: {
    isCreation() {
      return !this.note;
    },
  },
  methods: {
    submit() {
      this.saving = true;
      if (this.note) {
        notesServices
          .updateNote({
            message: this.message,
            noteID: this.note!.idMessage,
          })
          .then(
            () => {
              this.$emit("back", true);
            },
            (error) => (this.savingError = error)
          )
          .finally(() => (this.saving = false));
      } else {
        notesServices
          .addNote({ message: this.message, poolID: this.poolID! })
          .then(
            () => this.$emit("back", true),
            (error) => (this.savingError = error)
          )
          .finally(() => (this.saving = false));
      }
    },
  },
});
</script>

<template>
  <div>
    <klereo-banner
      left-icon="arrow-left"
      @left="$emit('back')"
      :title="$t('NewNote')"
    />

    <div class="lg:max-w-3xl lg:m-auto">
      <div class="card p-3 mb-2">
        <promise-wrapper :promise="promise">
          <loading-overlay :loading="saving" :error="savingError" />
          <h3 class="text-lg font-medium">{{ $t("NoteTargetPool") }}</h3>

          <select
            v-if="isCreation"
            class="form-select text-black mb-2"
            v-model="poolID"
            :disabled="!!note"
          >
            <option value="0" selected>
              {{ $t("NoteAllPools") }}
            </option>
            <option
              v-for="pool in pools"
              :key="pool.idSystem"
              :value="pool.idSystem"
            >
              {{ pool.poolNickname }}
            </option>
          </select>

          <input
            v-else
            class="form-input mb-2"
            disabled
            :value="note!.poolNickname"
          />

          <textarea
            v-model="message"
            placeholder="Entrez votre texte ici"
            class="form-textarea"
          ></textarea>

          <div class="flex justify-end mt-2">
            <button class="btn--secondary mr-2" @click="$emit('back')">
              {{ $t("Annuler") }}
            </button>
            <button class="btn--primary" @click="submit">
              {{ note ? $t("Modif") : $t("Ajouter") }}
            </button>
          </div>
        </promise-wrapper>
      </div>
    </div>
  </div>
</template>
